﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_franquia/franquia-analises-simulacao";

export const Route = createFileRoute("/_authenticated/franquia-analises-simulacao")({
  head: () => ({
    meta: [
      { title: "Simulações de compras — Milky Moo Palmares" },
      {
        name: "description",
        content: "Estime vendas por produto e veja quanto de cada insumo será necessário comprar.",
      },
      { property: "og:title", content: "Simulações de compras — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Estime vendas por produto e veja quanto de cada insumo será necessário comprar.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
